import {
  ADVERTISERDISCLOSUREWRAPPER,
  ARTICLEHEROWRAPPER,
  AWARDS2024BUTTONS,
  AWARDSNAVIGATION,
  AWARDSBADGEDROPDOWN,
  BAINREFERRALBANNERSC,
  BACKTOTOP,
  BORDERBANNER,
  CURRENTDATE,
  EDITORCONTROL,
  FLEXCARDS,
  FILTERS,
  GLOBALNAV,
  GRIDFORM,
  GRID,
  HORIZONTALBANNER,
  INPUTBUTTON,
  INSURANCESUMMARYTABLEWRAPPER,
  INSURANCEPRODUCTCARDWRAPPER,
  KETOPRODUCTCARD,
  LOTTIEANIMATION,
  MULTILEVELFILTERS,
  PAGE,
  RETIREMENTCALCULATORSC,
  STICKYHEADER,
  THIRDPARTYEMBED,
  OURVALUES,
  UNIVERSALACCORDION,
  UNIVERSALBULLETLIST,
  UNIVERSALBUTTON,
  UNIVERSALCONTAINER,
} from './lpc-types';

export const lpcSchema = {
  [ARTICLEHEROWRAPPER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDS2024BUTTONS]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSBADGEDROPDOWN]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [ADVERTISERDISCLOSUREWRAPPER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [AWARDSNAVIGATION]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [BAINREFERRALBANNERSC]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [BACKTOTOP]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [BORDERBANNER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [CURRENTDATE]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [PAGE]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [EDITORCONTROL]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [FLEXCARDS]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [FILTERS]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [GRIDFORM]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [GRID]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [KETOPRODUCTCARD]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [GLOBALNAV]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [HORIZONTALBANNER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [INPUTBUTTON]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [INSURANCESUMMARYTABLEWRAPPER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [INSURANCEPRODUCTCARDWRAPPER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [MULTILEVELFILTERS]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [THIRDPARTYEMBED]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [OURVALUES]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALCONTAINER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [RETIREMENTCALCULATORSC]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [STICKYHEADER]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALACCORDION]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALBULLETLIST]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [LOTTIEANIMATION]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
  [UNIVERSALBUTTON]: {
    nodeProps: ['children'],
    version: '1.0.0',
    migrations: {},
  },
};
